module.exports = {
  days: 'days',
  hours: 'hours',
  minutes: 'min',
};
